// @ts-nocheck
/* eslint-disable */
export const boldArrowDownCircleIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7.8 1.334C4.212 1.334 1.3 4.32 1.3 8s2.912 6.667 6.5 6.667S14.3 11.68 14.3 8s-2.912-6.666-6.5-6.666m2.294 7.353-1.95 2a.476.476 0 0 1-.689 0l-1.95-2a.51.51 0 0 1 0-.707.48.48 0 0 1 .69 0l1.117 1.147v-3.46c0-.273.221-.5.488-.5.266 0 .487.227.487.5v3.46L9.405 7.98a.48.48 0 0 1 .69 0 .51.51 0 0 1 0 .707"/></svg>`,
    name: 'bold-arrow-down-circle' as const
};